<script>
import store from '../store'
// 服务器的主域名
let siteUrl = ''
if (process.env.NODE_ENV !== 'development') {
  siteUrl = window.location.href.split(':')[0] + '://' + window.location.host
} else {
  siteUrl = 'http://175.178.71.142:9239' // http://192.168.2.51:8001'
}
// 关闭的颜色
const closeColor = '#909399'
// 开启的颜色
const opensColor = '#13ce66'
// 加载的文字
const loadingText = '拼命加载中'
// 倒计时秒数
const secondDjs = 3
// 登录进入
const loginPath = 'DataOverview'
// 当前版本
const versionNB = 'V21.07.1656'
// 色值组
const colorGroup = ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
// 路由权限
const routePower = []
// 组件导航
const elementNav = []
// 面包屑
const breadcrumb = []
// 快捷页址
const pathPage = []
// 用户权限
const userPower = []
// 权限开关
const PowerSwitch = false
// 全局显示id
const openID = true
// 全局控制表头显示
const tableHeader = true
// 屏幕高度
let screenHeight = document.documentElement.clientHeight || document.body.clientHeight
window.onresize = () => {
  store.commit('updateScreenHeight', document.documentElement.clientHeight)
}

export default {
  name: 'Global',
  siteUrl,
  closeColor,
  opensColor,
  loadingText,
  secondDjs,
  loginPath,
  versionNB,
  colorGroup,
  routePower,
  elementNav,
  breadcrumb,
  pathPage,
  userPower,
  PowerSwitch,
  screenHeight,
  openID,
  tableHeader
}
</script>



// WEBPACK FOOTER //
// src/components/Global.vue